// components/layout/PageRenderer.jsx
import { useRouter } from "../../contexts/RouterContext";

import Dashboard       from "../../pages/dashboard/Dashboard";
import CustomerList    from "../../pages/customers/CustomerList";
import CustomerForm    from "../../pages/customers/CustomerForm";
import CustomerDetail  from "../../pages/customers/CustomerDetail";
import KarigarsPage    from "../../pages/karigars/KarigarsPage";
import KarigarForm     from "../../pages/karigars/KarigarForm";
import OrderList       from "../../pages/orders/OrderList";
import OrderForm       from "../../pages/orders/OrderForm";
import OrderDetail     from "../../pages/orders/OrderDetail";
import Settings        from "../../pages/settings/Settings";
import PaymentList        from "../../pages/payments/PaymentList";
import ReceiptList        from "../../pages/receipts/ReceiptList";
import Reports            from "../../pages/reports/Reports";
import CompanyProfile     from "../../pages/profile/CompanyProfile";

export default function PageRenderer() {
  const { route } = useRouter();
  const { page, params } = route;

  switch (page) {
    case "dashboard":       return <Dashboard />;
    case "customers":       return <CustomerList />;
    case "customer-add":    return <CustomerForm />;
    case "customer-edit":   return <CustomerForm editId={params.id} />;
    case "customer-detail": return <CustomerDetail customerId={params.id} initialTab={params.tab} />;
    case "karigars":        return <KarigarsPage initialTab={params.tab} />;
    case "karigar-add":     return <KarigarForm />;
    case "karigar-edit":    return <KarigarForm editId={params.id} />;
    case "orders":          return <OrderList />;
    case "order-create":    return <OrderForm preCustomerId={params.customerId} />;
    case "order-edit":      return <OrderForm editId={params.id} />;
    case "order-detail":    return <OrderDetail orderId={params.id} />;
    case "settings":        return <Settings />;
    case "payments":        return <PaymentList />;
    case "receipts":        return <ReceiptList />;
    case "reports":         return <Reports />;
    case "profile":         return <CompanyProfile />;
    default:                return <Dashboard />;
  }
}
